import { render, staticRenderFns } from "./ConsignmentTracker.vue?vue&type=template&id=0ad8df80"
import script from "./ConsignmentTracker.vue?vue&type=script&lang=js"
export * from "./ConsignmentTracker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports